import React from 'react';
import {
  Carousel,
  Icon,
  Link,
  PLACEMENT,
  PopOverContent,
  PopOverTrigger,
  PopOverWrapper,
  TextRegular,
} from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import DealerItem from './DealerItem';
import { TFranchiseDealerItem } from 'types/TFranchiseDealersItem';

import Classes from './FranchiseDealerItemList.module.scss';

type TFranchiseDealerItemListProps = {
  totalItemsCount?: number;
  items: TFranchiseDealerItem[];
  itemClassName?: string;
  headerClassName?: string;
};

const FranchiseDealerItemList = ({
  items,
  totalItemsCount,
  itemClassName = Classes.item,
  headerClassName = Classes.header,
}: TFranchiseDealerItemListProps) => {
  const { t } = useI18nContext();
  const totalItemsText =
    !!totalItemsCount && totalItemsCount > 1 ? t('franchiseDealerItems.total', { count: totalItemsCount }) : undefined;
  const brandName = items[0]?.brand || '';

  return (
    <Carousel
      title={
        (
          <div className={Classes.carouselTitle}>
            {t('franchiseDealerItems.header', { brand: brandName })}

            <PopOverWrapper placement={PLACEMENT.BOTTOM}>
              <PopOverTrigger>
                <button className={Classes.infoButton}>
                  <Icon name="info" color="text-secondary" />
                </button>
              </PopOverTrigger>
              <PopOverContent>
                <TextRegular className={Classes.disclaimerContent}>
                  {t('carouselDisclaimer.text')}
                  <br />
                  <Link
                    href="https://help.marktplaats.nl/s/article/rangschikking-advertenties"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('carouselDisclaimer.link')}
                  </Link>
                </TextRegular>
              </PopOverContent>
            </PopOverWrapper>
          </div>
        ) as any
      }
      headerClassName={headerClassName}
      bodyText={totalItemsText}
    >
      {items.map((item, index) => (
        <DealerItem className={itemClassName} item={item} key={item.itemId} suppressZeroCents index={index} />
      ))}
    </Carousel>
  );
};

export default FranchiseDealerItemList;
